import { useCallback, useMemo } from 'react';

import useToast from '@bo-hooks/common/useToast';
import IB_Preset, { Custom_Preset } from '@bo-ibSheet/common';

const useOpenApiApprovalKey = () => {
  const { showToast } = useToast();

  const handleToast = useCallback(() => {
    showToast('복사되었습니다.');
  }, [showToast]);

  const openApiApprovalOptions = useMemo(
    () => ({
      LeftCols: [Custom_Preset.SEQ],
      Def: {
        Row: {
          Height: 44,
          CanFormula: true,
          CalcOrder: 'TextColor',
          TextColorFormula: ({ Row }) => (Row['useYn'] === 'Y' ? '#333333' : '#BBBBBB'),
        },
      },
      Cols: [
        {
          ...Custom_Preset.ClipboardTextToast(handleToast),
          Header: 'API승인KEY',
          Name: 'openApiApprovalKey',
          Key: 'OPEN_API_APPR_KEY',
          MinWidth: 120,
          Width: 1000,
          Align: 'Left',
          CanEdit: 0,
          RelWidth: 1,
          Size: 27,
        },
        {
          Header: '생성일시',
          Type: 'Date',
          Name: 'applyStartDateTime',
          Key: 'APPLY_START_DTIME',
          MinWidth: 120,
          Width: 150,
          Align: 'Center',
          CanEdit: 0,
          Size: 27,
          ...IB_Preset.YMD12HMS,
        },
        {
          Header: '만료일시',
          Type: 'Date',
          Name: 'applyEndDateTime',
          Key: 'APPLY_END_DTIME',
          MinWidth: 120,
          Width: 150,
          Align: 'Center',
          CanEdit: 0,
          Size: 27,
          ...IB_Preset.YMD12HMS,
        },
        {
          Header: '상태',
          Type: 'Text',
          Name: 'useYn',
          Key: 'USE_YN',
          MinWidth: 120,
          Width: 120,
          Align: 'Center',
          CanEdit: 0,
          Size: 27,
          Format: {
            Y: '사용가능',
            N: '사용불가',
          },
        },
      ],
    }),
    [handleToast]
  );

  return { openApiApprovalOptions };
};

export default useOpenApiApprovalKey;
